export const isPastDate = (isoDate: string): boolean => {
  const eventDate = new Date(isoDate);
  const currentDate = new Date();

  return eventDate < currentDate;
};
